"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteEntryService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const objectiveExplorer_1 = require("@branch-ts/practice-idps-web/src/objectiveExplorer/objectiveExplorer");
const web_1 = require("@branch-ts/web");
const web_consensus_1 = require("@branch-ts/web-consensus");
const service_VersetSingular_1 = require("./service.VersetSingular");
const verset_consensus_1 = require("@project/verset_consensus");
const checkoutFailure_1 = require("./market/checkoutFailure");
const checkoutSuccess_1 = require("./market/checkoutSuccess");
const service_VersetGuild_1 = require("./service.VersetGuild");
const service_VersetIC_1 = require("./service.VersetIC");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
const service_Verset_1 = require("./service.Verset");
const userBillingHistory_1 = require("./userBillingHistory/userBillingHistory");
const userProfile_1 = require("./userProfile/userProfile");
const aiTeamPage_1 = require("./userProfile/aiTeamPage");
const probeSetupGuide_1 = require("./view/probeSetupGuide");
let SiteEntryService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var SiteEntryService = class {
        static { _classThis = this; }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            SiteEntryService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        constructor() {
            this.layout = new web_consensus_1.SiteLeftBarLayout({
                leadingButton: {
                    icon: "back",
                    text: "Back to workspace",
                    onClick: () => {
                        web_consensus_1.UIMechanism.goto({ uri: "/" });
                    },
                },
            });
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetService: service_Verset_1.VersetService,
                VersetGuildService: service_VersetGuild_1.VersetGuildService,
                VersetICService: service_VersetIC_1.VersetICService,
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
                NavigationService: web_1.NavigationService,
                VersetSingularService: service_VersetSingular_1.VersetSingularService,
            });
        }
        async initialize() {
            web_consensus_1.PrettyTitle.enable();
            this.setupNavigations();
            await this.deps.VersetService.situations.wait("ready", true);
            await this.deps.NavigationService.handleUrl(window.location.href);
        }
        setupNavigations() {
            this.deps.NavigationService.addNavigation({
                name: "SingularView",
                path: "/",
                view: () => {
                    return new web_consensus_1.SingularView({
                        singularContext: this.deps.VersetSingularService.singular,
                    });
                },
                default: true,
                isFullscreen: true,
            }).addNavigation({
                name: "SingularAlias",
                path: "/singular",
                view: () => {
                    return new web_consensus_1.SingularView({
                        singularContext: this.deps.VersetSingularService.singular,
                    });
                },
                isFullscreen: true,
            }).addNavigation({
                name: "Dashboard",
                path: "/dashboard",
                view: this.layout,
                children: [{
                        name: "Profile",
                        path: "profile",
                        default: true,
                        view: () => {
                            const view = new userProfile_1.UserProfile();
                            view.presentContext.route(async () => { return; });
                            return view;
                        },
                    }, {
                        name: "Billing",
                        path: "billing",
                        view: () => {
                            const view = new userBillingHistory_1.UserBillingHistory();
                            view.presentContext.route(async () => { return; });
                            return view;
                        },
                    }, {
                        name: verset_consensus_1.VersetProtocol.ProductName.guild,
                        path: "ai-team",
                        view: () => {
                            const view = new aiTeamPage_1.AITeamPage();
                            view.present.route(async () => { return; });
                            return view;
                        },
                    }]
            }).addNavigation({
                name: "ProbePairing",
                path: "/pairing",
                view: () => {
                    return new probeSetupGuide_1.ProbeSetupGuide({ route: true });
                },
                isFullscreen: true,
            }).addNavigation({
                name: "IntelligenceCenter",
                path: "/ic",
                view: () => {
                    const intelligenceCenter = this.deps.VersetICService.intelligenceCenter;
                    if (!intelligenceCenter) {
                        return "NotFound";
                    }
                    return new objectiveExplorer_1.ObjectiveExplorer({
                        intelligenceCenter,
                        title: `${verset_consensus_1.VersetProtocol.ProductName.objective}s`,
                    });
                },
                isFullscreen: true,
            }).addNavigation({
                name: "Guild",
                path: "/guild/my",
                view: () => {
                    const view = new aiTeamPage_1.AITeamPage();
                    view.present.route(async () => { return; });
                    return view;
                },
                isFullscreen: true,
            }).addNavigation({
                name: "IdpsStandaloneAlias",
                path: "/idps/standalone",
                view: "IdpExplorerStandalone",
                isFullscreen: true,
            }).addNavigation({
                name: "Idps",
                path: "/idps",
                view: "IdpExplorer",
                isFullscreen: true,
            }).addNavigation({
                name: "legacyUserProfile",
                path: "/user/profile",
                view: () => {
                    window.location.href = "/dashboard/profile";
                    return "NotFound";
                },
                isFullscreen: true,
            }).addNavigation({
                name: "CheckoutSuccess",
                path: "/payment/checkout/success",
                view: () => {
                    return new checkoutSuccess_1.CheckoutSuccess();
                },
                isFullscreen: true,
            }).addNavigation({
                name: "CheckoutFailure",
                path: "/payment/checkout/failure",
                view: () => {
                    return new checkoutFailure_1.CheckoutFailure();
                },
                isFullscreen: true,
            });
        }
    };
    return SiteEntryService = _classThis;
})();
exports.SiteEntryService = SiteEntryService;
